module.exports = __webpack_public_path__ + "static/media/cursor_ai_ex.5e8d2e1d.png";